module.exports = __webpack_public_path__ + "static/media/home@3x.528a12ac.jpg";